/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, Input} from '@angular/core';
import {Observable} from "rxjs/Observable";


@Component({
  selector: 'program-information-list',
  templateUrl: 'program-information-list.html'
})
export class ProgramInformationListComponent {

  @Input()
  items: {name: string, description: string}[];

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/program-information-list/program-information-list.ts